import React, { useState, useEffect } from "react";
import {
    Form,
    Input,
    FormInstance,
    Cascader,
    TreeSelect,
    Spin,
    Space,
    Button,
    Row,
    Col,
    Upload,
    notification, Select, Table, Image, Radio, Tooltip, Tag,
    Checkbox
} from "antd";
import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import {
    deleteTemplateMacDiskManagement, addTemplateMacDiskManagement, getTemplateMacDiskManagement
} from "../../../axios/api.device"

import { useTranslation } from "react-i18next";
import i18n from "@src/locales";
import { UploadChangeParam, UploadFile } from "antd/es/upload";

const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentMacDiskManagement = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [dataForm] = Form.useForm();
    const [isUpload, setIsUpload] = useState<boolean>(false);
    const [imageUrl, setImageUrl] = useState<any>('');
    const [isAdd, setIsAdd] = useState<boolean>(false);
    const { t } = useTranslation();

    var addClick = () => {
        setShowTable(2)
    }
    useEffect(() => {
        getDataInfo()
    }, [])
    
    const getDataInfo = () => {
        getTemplateMacDiskManagement(templateId).then((res) => {
            if (res && res != null && res.diskControls) {
                setShowTable(2)
                setIsAdd(false);
                dataForm?.setFieldsValue(res);
            } else {
                setShowTable(1)
                setIsAdd(true);
                setIsUpload(true);
            }
        })
    }

    const addTemplateClick = () => {
        dataForm?.validateFields().then(
            (res) => {
                console.log(res);
                addTemplateMacDiskManagement(templateId, res).then(() => {
                    updateTemplate();
                    notification.success({ message: t("保存成功") });
                    getDataInfo();
                })
            })
    }

    const deleteTemplateClick = () => {
        dataForm.validateFields().then(() => {
            deleteTemplateMacDiskManagement(templateId).then(() => {
                updateTemplate();
                notification.success({ message: t("删除成功") });
                dataForm.resetFields();
                getDataInfo();
            })
        })

    }

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle"> {t("磁盘存储")}</Col>
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (

                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("设置Mac磁盘存储")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <>
                        <Form
                            style={{ width: "90%", marginTop: 36 }}
                            layout="horizontal"
                            form={dataForm}
                            labelCol={{ span: 8 }}
                            initialValues={{}}
                        >
                            <Row>
                                <Col span={16}>
                                    <Item
                                        label={t("外部磁盘权限")}
                                        name="diskControls"
                                        rules={[{ required: true }]}
                                        extra={t("外置磁盘包括SD卡和USB闪存驱动器。该策略需设备重启生效")}
                                    >
                                        <Checkbox.Group>
                                            <Checkbox value="authenticate">{t("需要验证管理员权限")}</Checkbox>
                                            <Checkbox value="read-only">{t("只读")}</Checkbox>
                                            <Checkbox value="deny">{t("禁止")}</Checkbox>
                                            <Checkbox value="eject">{t("弹出")}</Checkbox>
                                        </Checkbox.Group>
                                    </Item>
                                </Col>
                            </Row>

                        </Form>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); }}>{t("删除规则")}</Button>
                        </div>
                    </>
                )}
            </Row>
        </div>

    </>)
};